import * as React from 'react';
import styled from 'styled-components';

import { maxSizes } from '../../utils/breakpoints';

const EiffelTowerSVG = styled.svg`
  height: 220px;
  width: 200px;
  margin-bottom: 15px;
  transform: scale(3);

  @media ${maxSizes.mobile} {
    transform: scale(1.2);
  }
`;

interface IEiffelTowerProps {
  className?: string;
}

const EiffelTower: React.FC<IEiffelTowerProps> = ({ className }) => (
  <EiffelTowerSVG
    fill="#663399"
    preserveAspectRatio="xMaxYMax meet"
    className={className}
  >
    <path d="M156.095,219.297h-18.856c-1.381,0-2.5-1.119-2.5-2.5c0-13.835-11.255-25.091-25.09-25.091s-25.091,11.256-25.091,25.091  c0,1.381-1.119,2.5-2.5,2.5H63.202c-0.888,0-1.709-0.471-2.158-1.238c-0.448-0.767-0.456-1.714-0.021-2.488l19.743-35.1v-9.935  c0-1.381,1.119-2.5,2.5-2.5h2.232l9.486-31.335l-3.637-4.547c-0.601-0.75-0.717-1.778-0.301-2.645  c0.417-0.866,1.292-1.417,2.253-1.417h2.408c1.055-5.604,3.976-23.151,5.313-51.681c1.651-35.234,2.038-51.247,2.041-51.404  c0-0.019,0.001-0.037,0.002-0.055c-0.974-0.948-1.58-2.272-1.58-3.736v-6.045c0-2.875,2.339-5.214,5.213-5.214h0.452V2.5  c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5v7.458h0.451c2.875,0,5.214,2.339,5.214,5.214v6.045c0,1.463-0.606,2.788-1.58,3.736  c0,0.018,0.001,0.037,0.002,0.055c0.003,0.158,0.391,16.183,2.041,51.405c1.338,28.53,4.259,46.077,5.313,51.681h2.408  c0.961,0,1.837,0.551,2.253,1.417c0.416,0.866,0.299,1.895-0.301,2.645l-3.637,4.547l9.486,31.335h2.231c1.381,0,2.5,1.119,2.5,2.5  v9.935l19.744,35.1c0.436,0.774,0.428,1.721-0.021,2.488C157.804,218.826,156.983,219.297,156.095,219.297z M139.636,214.297h12.185  l-17.252-30.671H84.729l-17.252,30.671h12.184c1.274-15.427,14.237-27.591,29.988-27.591S138.361,198.87,139.636,214.297z   M85.767,178.626h47.763v-5.59H85.767V178.626z M122.355,168.036h6.219l-9.428-31.146c-0.239-0.788-0.074-1.643,0.44-2.286  l1.209-1.512H98.501l1.209,1.512c0.514,0.643,0.679,1.498,0.44,2.286l-9.428,31.146h6.219l4.355-23.228  c0.222-1.182,1.254-2.039,2.457-2.039h11.79c1.203,0,2.235,0.857,2.457,2.039L122.355,168.036z M102.028,168.036h15.24l-3.8-20.267  h-7.641L102.028,168.036z M100.799,128.092h17.698c-1.21-6.588-3.918-23.779-5.215-51.446c-1.291-27.542-1.811-43.378-1.979-49.08  h-3.311c-0.168,5.702-0.688,21.539-1.979,49.08C104.718,104.313,102.009,121.504,100.799,128.092z M106.697,14.958  c-0.118,0-0.213,0.096-0.213,0.214v6.045c0,0.118,0.096,0.214,0.213,0.214h5.903c0.118,0,0.214-0.096,0.214-0.214v-6.045  c0-0.118-0.096-0.214-0.214-0.214H106.697z" />
  </EiffelTowerSVG>
);

export default EiffelTower;
